export default {
  getSitesList: state => {
    return state.sitesList
  },
  getSourcesList: state => {
    return state.partnersList.filter(partner => partner.type === 'BUYING');
  },
  getPartnersList: state => {
    return state.partnersList.filter(partner => partner.type !== 'BUYING');
  },
  getAllPartnersList: state => {
    return state.partnersList;
  },
  getMarketsList: state => {
    return state.marketsList;
  },
  getDevicesList: state => {
    return state.devicesList;
  },

  isBaseDataLoaded: state => {
    return state.isBaseDataLoaded;
  },

  getSideBarStatus: state => {
    return state.sideBarStatus;
  },

  isUserAuthorized: state => {
    return state.isUserAuthorized;
  },

  getAuthToken: state => {
    return state.authToken;
  },

  getUserData: state => {
    return state.userData;
  },

  getPartnerByPartnerId: state => (id) => {
    return state.partnersList.find(partner => partner.id === id);
  },
  getScrollOffsetY: state => {
    return state.scrollOffsetY;
  },

  getURLParams: state => {
    return state.URLparams;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/base/getters.js